'use client'

import type { ActionResult } from './action-result'
import { useTranslations } from 'next-intl'
import { toast } from 'sonner'

export function useActionToast() {
  const t = useTranslations()

  function showError(result: Extract<ActionResult, { ok: false }>) {
    const message = t(result.errorKey, result.errorValues)
    toast.error(message)
  }

  function showSuccess(message: string) {
    toast.success(message)
  }

  return { showError, showSuccess, t }
}
